import LiveCallPlugin from "../plugins/LiveCallPlugin/LiveCallPlugin";

/**
 * LiveCallPage — thin wrapper around LiveCallPlugin.
 * The plugin owns ALL state (idle/connecting/active/ending).
 * Never unmount the plugin conditionally — it manages its own lifecycle.
 */

function getWsUrl(): string {
  // Prefer explicit API base from env (handles local dev on different ports)
  const apiBase = (import.meta as any).env?.VITE_API_BASE_URL || "";
  if (apiBase) {
    return apiBase.replace(/^http/, "ws").replace(/\/$/, "") + "/ws/live-call";
  }
  // Fallback: same host (works in production behind nginx reverse proxy)
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}/ws/live-call`;
}

export default function LiveCallPage() {
  return (
    <div style={{
      height: "100%", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      background: "var(--surface-muted)", padding: 24,
    }}>
      <div style={{
        background: "var(--surface-raised)", borderRadius: "var(--radius-xl)",
        border: "1px solid var(--border-subtle)", padding: "32px 40px",
        display: "flex", flexDirection: "column", alignItems: "center", gap: 20,
        minWidth: 300, maxWidth: 420, width: "100%",
        boxShadow: "var(--shadow-card)",
      }}>
        {/* AI avatar */}
        <div style={{
          width: 80, height: 80, borderRadius: "50%",
          background: "var(--accent-light)",
          display: "flex", alignItems: "center", justifyContent: "center",
          border: "3px solid var(--accent)",
        }}>
          <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round">
            <circle cx="12" cy="8" r="2.5" />
            <path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" />
          </svg>
        </div>

        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 900, color: "var(--text-primary)" }}>
          AI Voice Assistant
        </h2>
        <p style={{ margin: 0, fontSize: 13, color: "var(--text-muted)", textAlign: "center" }}>
          Speak naturally — the AI listens and responds in real time.
        </p>

        {/* Plugin stays mounted forever — it manages its own lifecycle */}
        <LiveCallPlugin wsUrl={getWsUrl()} />
      </div>
    </div>
  );
}
